// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Nqxh","notes":"Notes_notes__240pL"};